/*
 * GradesGridNew Messages
 *
 * This contains all the text for the GradesGridNew component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts.grades.GradesGridNew';

export default defineMessages({
  studentName: {
    id: `${scope}.studentName`,
    defaultMessage: 'Student name',
  },
  total: {
    id: `${scope}.total`,
    defaultMessage: 'Total',
  },
  numberOfStudents: {
    id: `${scope}.numberOfStudents`,
    defaultMessage: '{num, number} {num, plural, one {student} other {students}}',
  },
  noTitle: {
    id: `${scope}.noTitle`,
    defaultMessage: '(No title)',
  },
  unattempted: {
    id: `${scope}.unattempted`,
    defaultMessage: 'Unattempted',
  },
  na: {
    id: `${scope}.na`,
    defaultMessage: 'N/A',
  },
  inProgress: {
    id: `${scope}.inProgress`,
    defaultMessage: 'In progress',
  },
  gradeButtonLabel: {
    id: `${scope}.gradeButtonLabel`,
    defaultMessage: 'Grade',
  },
});
